<script>
    // Licensed under Gnu Public Licence version 2
    // Copyright (c) 2023 (original work) Open Assessment Technologies SA ;

    /**
     * @property {string} [color] (neutral|success|warning|alert)- color of the text
     * @property {string} [text] - text to display
     */
    export let color = 'neutral';
    export let text;
</script>

<style>
    .badge-wrapper {
        display: flex;
        align-items: center;
        height: 100%;
    }
    .badge {
        border-radius: 2rem;
        padding: 0 var(--space-1x);
        font-size: var(--fontsize-body-xs);
        margin-left: var(--space-1x);
        font-weight: bold;
        line-height: normal;

        &.neutral {
            background-color: var(--color-brand-light);
            color: var(--color-brand);
        }

        &.success {
            background-color: var(--color-success-alternative-bg);
            color: var(--color-success);
        }

        &.warning {
            background-color: var(--color-partial-alternative-bg);
            color: var(--color-partial);
        }

        &.alert {
            background-color: var(--color-alert-alternative-bg);
            color: var(--color-alert);
        }
    }
</style>

{#if $$slots.default}
    <div class="badge-wrapper">
        <slot />
        <span class={`badge ${color}`}>{text}</span>
    </div>
{:else}
    <span class={`badge ${color}`}>{text}</span>
{/if}
